export enum OpportunityAction {
    Edit = 1,
    Archive = 2,
    EditContact = 3,
    EditUser = 4,
    Restore = 5,
    CreateEstimate = 6,
    EditCompany = 7,
    EditBuilding = 8
}
